import { ROUTE_RISK_ANALYSIS } from '@/constants/routes';
import { Badge, Box, Flex, IconArrowRight, Link, Text } from '@cmpsr/components';

import { Link as ReactRouterLink } from 'react-router-dom';

type DashboardRiskHeaderProps = {
  cancersBelow: number;
  cancersAbove: number;
  cancersAverage: number;
};

type RiskBadgeProps = {
  count: number;
  label: string;
  backgroundColor: string;
};

const RiskBadge = ({ count, label, backgroundColor }: RiskBadgeProps) => (
  <Link
    as={ReactRouterLink}
    to={ROUTE_RISK_ANALYSIS}
    tabIndex={0}
    aria-label={label}
    flexDirection="column"
    py={2}
    px={3}
    background={{ bg: 'background-container-default' }}
    borderRadius="radii-2"
    _hover={{ bg: 'background-container-hover' }}
    _focus={{ bg: 'background-container-hover' }}
    _active={{ bg: 'background-container-pressed' }}
  >
    <Badge backgroundColor={backgroundColor} mb="2" p="2" px="3" color="primary" borderRadius="radii-2">
      <Text variant="text-body-bold">{count}</Text>
    </Badge>
    <Text variant="text-body-meta-regular">{label}</Text>
  </Link>
);

export default function DashboardRiskHeader({ cancersBelow, cancersAbove, cancersAverage }: DashboardRiskHeaderProps) {
  return (
    <Box mb="6">
      <Text as="h2" variant="text-header-M" mb={5}>
        Risk By Cancer
      </Text>
      <Flex
        flexDirection={'row'}
        justifyContent="space-around"
        gap="4"
        border="1px solid"
        borderColor="ui-element-divider"
        borderTopRadius="radii-3"
        bgColor="background-light"
        p="4"
        textAlign="center"
      >
        <RiskBadge count={cancersBelow} label="Cancers Below Average" backgroundColor="alert-success-default" />
        <RiskBadge count={cancersAverage} label="Cancers Average Risk" backgroundColor="alert-warning-default" />
        <RiskBadge count={cancersAbove} label="Cancers Above Average" backgroundColor="alert-error-default" />
      </Flex>
      <Link
        as={ReactRouterLink}
        to={ROUTE_RISK_ANALYSIS}
        w="100%"
        borderTopRadius="none"
        borderBottomRadius="radii-3"
        border="1px solid"
        borderTop="none"
        borderColor="ui-element-divider"
        backgroundColor="background-page"
        trailingIcon={<IconArrowRight size="s" />}
        bgColor="background-page"
        display="flex"
        justifyContent="center"
        p="2"
      >
        View Full Risk Analysis
      </Link>
    </Box>
  );
}
